/*
Copyright 2024 New Vector Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-NevaiMeet-Commercial
Please see LICENSE in the repository root for full details.
*/

import { type FC } from "react";

import { formatDuration } from "./useCallTimer";
import styles from "./CallTimer.module.css";

export const CallTimerOverlay: FC<{ seconds: number }> = ({ seconds }) => (
  <div className={styles.overlay} aria-hidden="true">
    {formatDuration(seconds)}
  </div>
);
